import React from "react";
import { useEffect, useState } from "react";
import "./RoboTaxiPopup.css";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText
} from "@mui/material";

const RobotaxiPopNew = ({
  roboTaxiAlert = false,
  selectedPSL = [],
  setSelectedPSL = () => { },
  pslList = [],
  roboTaxiCountError = "",
  setRoboTaxiCountError = () => { },
  handleSaveLimit = () => { },
  onCancelRoboTaxi = () => { }
}) => {  
  const [selectedGroups, setSelectedGroups] = useState([]);
  const groupOptions = [...new Set(pslList.map(p => p.groupName))];
  // ✅ Safely extract PSL names
  const selectedPSLNames = Array.isArray(selectedPSL) 
    ? selectedPSL.map(p => p?.pslName || p).filter(Boolean)
    : [];
  // ✅ FIX: Update selectedGroups whenever selectedPSL changes
  useEffect(() => {
    if (selectedPSL && selectedPSL.length > 0) {
      const groupsFromPSL = [
        ...new Set(selectedPSL.map(p => p.groupName).filter(Boolean))
      ];
      setSelectedGroups(groupsFromPSL);
    } else {
      console.log("🔍 No PSLs selected");
    }
  }, [selectedPSL]); // ✅ Changed from [roboTaxiAlert] to [selectedPSL]

  // ✅ Filter PSLs based on selected groups
 const filteredPSLList = selectedGroups.length > 0
  ? pslList.filter(p => selectedGroups.includes(p.groupName))
  : []; // ✅ empty when no group selected

  const handleCancel = () => {
    onCancelRoboTaxi();
  };

  return (
    <>
      {roboTaxiAlert && (
        <div className="popup-container">
          <div className="popup">

            <span className="heading-title">
              Assign Spaces for RoboTaxis
            </span>
            <p>
              <span  style={{fontSize: "12px",fontWeight:5, marginBottom: "2px", display: "block", textAlign: "left"}}>
                Select a group and parking spaces for robo-taxis.</span>
            </p>
            {/* ================= GROUP ================= */}
            <div style={{ marginBottom: "22px", textAlign: "left" }}>
              <label
                style={{fontWeight: 600, width: 140}}
              >
                Group <span style={{ color: "red" }}>*</span>
              </label>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  value={selectedGroups}
                  onChange={(e) => {
                    const value = e.target.value;
                    
                    // ✅ Handle "All Groups" selection
                    if (value.includes("ALL")) {
                      if (selectedGroups.length === groupOptions.length) {
                        setSelectedGroups([]);
                        setSelectedPSL([]); // Clear PSLs when deselecting all
                      } else {
                        setSelectedGroups(groupOptions);
                      }
                      return;
                    }
                    
                    setSelectedGroups(value);
                    
                    // ✅ Keep only PSLs that belong to newly selected groups
                    if (value.length > 0) {
                      const validPSLs = selectedPSL.filter(psl => 
                        value.includes(psl.groupName)
                      );
                      if (validPSLs.length !== selectedPSL.length) {
                        setSelectedPSL(validPSLs);
                      }
                    } else {
                      // If no groups selected, clear PSLs
                      setSelectedPSL([]);
                    }
                    
                    setRoboTaxiCountError("");
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select Groups";
                    if (selected.length === groupOptions.length) return "All Groups";
                    return selected.join(", ");
                  }}
                >
                  {/* All Groups Option */}
                  <MenuItem value="ALL">
                    <Checkbox
                      checked={selectedGroups.length === groupOptions.length && groupOptions.length > 0}
                      indeterminate={selectedGroups.length > 0 && selectedGroups.length < groupOptions.length}
                    />
                    <ListItemText primary="All Groups" />
                  </MenuItem>

                  {groupOptions.map(group => (
                    <MenuItem key={group} value={group}>
                      <Checkbox checked={selectedGroups.includes(group)} />
                      <ListItemText primary={group} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Parking Spaces - MULTIPLE from filtered groups */}
            <div style={{ marginBottom: "22px", textAlign: "left" }}>
              <label style={{ fontWeight: 600, width: 140 }}>
                Parking Spaces <span style={{ color: "red" }}>*</span>
              </label>

              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  value={selectedPSLNames}
                  disabled={selectedGroups.length === 0}
                  onChange={(e) => {
                    const values = e.target.value;
                    if (values.includes("ALL")) {
                      const allObjects = filteredPSLList.map(p => ({
                        pslName: p.label,
                        groupName: p.groupName
                      }));
                      setSelectedPSL(allObjects);
                      setRoboTaxiCountError("");
                      return;
                    }
                    
                    if (values.length === 0) {
                      setSelectedPSL([]);
                      return;
                    }

                    const selectedObjects = values
                      .map(val => {
                        const match = filteredPSLList.find(p => p.label === val);
                        if (!match) {
                          console.warn("⚠️ No match found for:", val);
                          return null;
                        }
                        return {
                          pslName: val,
                          groupName: match.groupName
                        };
                      })
                      .filter(Boolean);
                    setSelectedPSL(selectedObjects);
                    
                    if (selectedObjects.length > 0) {
                      setRoboTaxiCountError("");
                    }
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select PSLs";
                    if (filteredPSLList.length > 0 && selected.length === filteredPSLList.length) {
                      return "All PSLs";
                    }
                    return selected.join(", ");
                  }}
                >
                  <MenuItem value="ALL">
                    <Checkbox
                      checked={
                        filteredPSLList.length > 0 &&
                        filteredPSLList.every(p => selectedPSLNames.includes(p.label))
                      }
                      indeterminate={
                        selectedPSLNames.length > 0 &&
                        selectedPSLNames.length < filteredPSLList.length
                      }
                    />
                    <ListItemText primary="All PSLs" />
                  </MenuItem>

                  {filteredPSLList.length === 0 ? (
                    <MenuItem disabled>
                      <ListItemText primary="Select groups first" />
                    </MenuItem>
                  ) : (
                    filteredPSLList.map((p) => (
                      <MenuItem key={p.id} value={p.label}>
                        <Checkbox checked={selectedPSLNames.includes(p.label)} />
                        {/* <ListItemText primary={`${p.label} (${p.groupName})`} /> */}
                        <ListItemText primary={`${p.label}`} />
                      </MenuItem>
                    ))
                  )}
                </Select>
                 {/* Error */}
            {roboTaxiCountError && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                  {roboTaxiCountError}
                </div>
              )}
              </FormControl>
            </div>                

            {/* ================= BUTTONS ================= */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "12px"
              }}
            >
              <button className="cancel-buttons" onClick={onCancelRoboTaxi}>
                Cancel
              </button>

              <button className="add-property-btns" onClick={handleSaveLimit}>
                Assign to Robo-taxi
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RobotaxiPopNew;
